import AppRatingAPI from 'api/app-rating';
import JobsAPI from 'api/jobs';

const getInitialState = async ({state, params}) => {
    const {jobId} = params;

    const [appRating, selectedJob] = await Promise.all([
        AppRatingAPI.get(),
        JobsAPI.getJobById(jobId),
    ]);

    return {
        ...state,
        appRating: {...appRating, isPending: false},
        jobs: {
            data: {
                pending: false,
                jobs: null,
                selectedJob,
            },
        },
    };
};

export default getInitialState;
